import { Button } from '../ui/Button'
import { trackCTA } from '../../lib/firebase'

export function Hero() {
    return (
        <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
            {/* Background Gradient */}
            <div className="absolute inset-0 bg-gradient-to-br from-dpxp-primary via-dpxp-secondary to-dpxp-primary" />

            {/* Background Pattern - Circles */}
            <div className="absolute top-0 right-0 w-2/3 h-full opacity-30 pointer-events-none">
                <img
                    src="/assets/background-hero-circulos-sobrepostos-banner-lateral-direita.svg"
                    alt=""
                    className="w-full h-full object-cover object-left"
                />
            </div>

            {/* Content */}
            <div className="container-section relative z-10 pt-20">
                <div className="grid lg:grid-cols-2 gap-8 items-center">
                    {/* Text Content */}
                    <div className="text-white text-center lg:text-left">
                        {/* Headline */}
                        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
                            Clareza na TI, Vantagem no Negócio
                        </h1>

                        {/* Subtitle */}
                        <h2 className="text-xl md:text-2xl font-light mb-8 text-white/90">
                            Otimizando sua Estrutura de TI com Governança, Dados e Arquitetura Corporativa.
                        </h2>

                        {/* Description */}
                        <p className="text-lg md:text-xl mb-10 text-white/80 leading-relaxed">
                            <strong className="text-white">Transformamos áreas fragmentadas em trajetórias claras.</strong>
                            <br className="hidden md:block" />
                            Na DPXP, a tecnologia é feita de gente para gente. Ajudamos sua empresa a deixar de ver a TI como centro de custo para torná-la uma aliada estratégica do negócio.
                        </p>

                        {/* CTA Button */}
                        <Button href="#contato" variant="primary" size="lg" onClick={() => trackCTA('fale_com_especialista', 'hero')}>
                            Fale com um Especialista
                        </Button>
                    </div>

                    {/* Hero Image */}
                    <div className="hidden lg:flex justify-center items-center">
                        <div className="relative w-full max-w-xl">
                            <div className="absolute -inset-8 bg-white/10 rounded-3xl blur-2xl"></div>
                            <img
                                src="/assets/desenvolvedora-mobile-construindo-app-ab-testing-cloud-code-alinhado-direita.svg"
                                alt="Desenvolvimento de soluções tecnológicas"
                                className="relative w-full h-auto drop-shadow-2xl"
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Scroll indicator */}
            <div className="absolute bottom-8 inset-x-0 flex justify-center animate-bounce">
                <div className="w-8 h-12 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
                    <div className="w-1 h-3 bg-white/80 rounded-full"></div>
                </div>
            </div>
        </section>
    )
}
